<template>
  <div class="teacher_data">
    <div class="personal_data_wrapper fadeIn" v-if="userInfo">
      <div class="order-details-page mb-5">
        <div class="row py-2 mx-1 justify-content-center align-items-center">
          <div
            class="col-12 d-flex justify-content-between align-items-center mb-4"
          >
            <h4 class="main_color m-0">
              مخالفات المندوبين ({{ userInfo.full_name }})
            </h4>
            <div class="d-flex">
              <v-btn
                depressed
                color="error"
                class="ml-3 text-white"
                @click="openAddFineModal"
              >
                <i class="fal fa-plus-circle ml-1"></i> إضافة مخالفة
              </v-btn>
              <v-btn
                depressed
                color="success"
                @click="exportFines"
                :loading="isExporting"
              >
                <i class="fal fa-file-excel ml-1"></i> تحميل Excel
              </v-btn>
            </div>
          </div>

          <div class="col-12">
            <main>
              <v-data-table
                class="thumb strip"
                :headers="headers"
                :items="fines"
                :loading="loading"
                :loading-text="$t('table.loadingData')"
                item-key="id"
                :items-per-page="paginations.items_per_page"
                hide-default-footer
              >
                <template v-slot:no-data>
                  {{ $t("table.noData") }}
                </template>

                <template v-slot:[`item.index`]="{ index }">
                  {{ index + 1 }}
                </template>

                <template v-slot:[`item.order_id`]="{ item }">
                  <router-link
                    v-if="item.order_id"
                    :to="`/delivery_orders/show/${item.order_id}`"
                    class="main_color text-decoration-underline"
                  >
                    #{{ item.order_id }}
                  </router-link>
                  <span v-else>-</span>
                </template>

                <template v-slot:[`item.note`]="{ item }">
                  <span>{{ item.note || "-" }}</span>
                </template>

                <template v-slot:[`item.admin.full_name`]="{ item }">
                  <span>{{ item.admin ? item.admin.full_name : "-" }}</span>
                </template>
              </v-data-table>
            </main>

            <!-- Start Pagination -->
            <div
              class="pagination_container text-center mb-5 d-flex justify-content-end mt-4"
            >
              <v-pagination
                v-model.number="paginations.current_page"
                :length="paginations.last_page"
                :total-visible="5"
                @input="fetchData($event)"
              ></v-pagination>
            </div>
            <!-- End Pagination -->
          </div>
        </div>
      </div>
    </div>

    <!-- Apply Fine Dialog -->
    <v-dialog v-model="addFineDialog" width="450">
      <v-card class="p-4">
        <form @submit.prevent="submitAddFine">
          <h5 class="main_color text-center mb-4">
            تطبيق مخالفة جديدة على المندوب
          </h5>

          <div class="input_wrapper top_label mb-4">
            <label class="form-label">السبب*</label>
            <multiselect
              v-model="fineForm.cancel_reason"
              :options="cancelReasons"
              label="name"
              track-by="id"
              placeholder="اختر السبب"
              :searchable="true"
              :allow-empty="false"
              :show-labels="false"
            ></multiselect>
          </div>

          <div class="input_wrapper top_label mb-4">
            <textarea
              class="form-control"
              v-model.trim="fineForm.note"
              rows="4"
            />
            <label class="form-label">ملاحظة</label>
          </div>

          <div class="text-center mt-4">
            <v-btn
              depressed
              color="error"
              class="px-10 text-white"
              :loading="isSubmitting"
              type="submit"
            >
              ارسال
            </v-btn>
            <v-btn depressed class="px-10 mr-2" @click="addFineDialog = false">
              إلغاء
            </v-btn>
          </div>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["userInfo"],

  data() {
    return {
      fines: [],
      loading: false,
      isExporting: false,
      isSubmitting: false,
      addFineDialog: false,
      cancelReasons: [],
      fineForm: {
        cancel_reason: null,
        note: "",
      },
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },
    };
  },

  computed: {
    headers() {
      return [
        {
          text: "#",
          align: "center",
          value: "index",
          sortable: false,
          width: "80",
        },
        {
          text: "السبب",
          align: "center",
          value: "reason",
          sortable: false,
        },
        {
          text: "الملاحظات",
          align: "center",
          value: "note",
          sortable: false,
        },
        {
          text: "الآدمن المطبّق",
          align: "center",
          value: "admin.full_name",
          sortable: false,
        },
        {
          text: "رقم الطلب",
          align: "center",
          value: "order_id",
          sortable: false,
        },
        {
          text: "تاريخ المخالفة",
          align: "center",
          value: "created_at",
          sortable: false,
        },
      ];
    },
  },

  methods: {
    getData() {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: `driver/${this.userInfo.id}/fines`,
        params: {
          page: this.paginations.current_page,
        },
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta?.last_page || 1;
          this.paginations.items_per_page = res.data.meta?.per_page || 20;
          this.fines = res.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response?.data?.message || "فشل تحميل البيانات",
            position: "bottomRight",
          });
          this.loading = false;
        });
    },

    fetchData(page) {
      this.paginations.current_page = page;
      this.getData();
    },

    openAddFineModal() {
      this.fineForm.cancel_reason = null;
      this.fineForm.note = "";
      this.addFineDialog = true;
    },

    submitAddFine() {
      if (!this.fineForm.cancel_reason) {
        this.$iziToast.error({
          message: "يرجى اختيار سبب المخالفة",
          position: "bottomRight",
        });
        return;
      }
      this.isSubmitting = true;

      const submitData = {
        cancel_reason_id: this.fineForm.cancel_reason.id,
        reason: this.fineForm.cancel_reason.name,
        note: this.fineForm.note,
      };

      this.$axios({
        method: "POST",
        url: `driver/${this.userInfo.id}/fines`,
        data: submitData,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message || "تم إضافة المخالفة بنجاح",
            position: "bottomRight",
          });
          this.addFineDialog = false;
          this.isSubmitting = false;
          this.paginations.current_page = 1;
          this.getData();
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response?.data?.message || "فشل إضافة المخالفة",
            position: "bottomRight",
          });
          this.isSubmitting = false;
        });
    },

    exportFines() {
      this.isExporting = true;
      this.$axios({
        method: "GET",
        url: `driver/${this.userInfo.id}/fines/export`,
        responseType: "blob",
      })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `مخالفات_${this.userInfo.fullname || "المندوب"}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          this.isExporting = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: "فشل تصدير البيانات إلى Excel",
            position: "bottomRight",
          });
          this.isExporting = false;
        });
    },
    getCancelReasons() {
      this.$axios({
        method: "GET",
        url: "cancel_reason_not_paginated?reason_type=fine",
      })
        .then((res) => {
          this.cancelReasons = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },

  created() {
    if (this.userInfo && this.userInfo.id) {
      this.getData();
    }
    this.getCancelReasons();
  },
};
</script>

<style scoped>
.border-right-0 {
  border-right-width: 0 !important;
}
.icon {
  padding: 7px 10px;
}
.teacher_data .item .info {
  background-color: white !important;
}
</style>
